import { Assignment } from "./assignment";
import { Customer } from "./customer";
import { CustomerContactCard } from "./customer-contact-card";
import { Employee } from "./employee";
import { Feedback } from "./feedback";
import { Message } from "./message";
import { ShiftBreak } from "./shift-break";
import { ShiftInvoicable } from "./shift-invoicable";
import { ShiftProduct } from "./shift-product";
import { Task } from "./task";

export class Shift {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    updated_by_id!: number;
    customer_id!: number;
    customer: Customer = new Customer();
    employee_id!: number;
    employee: Employee = new Employee()
    assignment_id!: number;
    assignment: Assignment = new Assignment();
    start!: string;
    end!: string;
    lunch_start!: string;
    lunch_end!: string;
    duration!: number;
    lunch!: number;
    notes!: string;
    customer_notes!: string;
    type!: string;
    status!: string;
    verified!: boolean;
    reserved!: boolean;
    no_pay!: boolean;
    no_invoice!: boolean;
    paid!: boolean;
    invoiced!: boolean;
    confirmed_customer!: boolean;
    confirmed_employee!: boolean;
    salary_rules_id!: number;
    salary_rules_ruleset_id!: number;
    employment_id!: number;
    pricing_id!: number;
    total_salary!: number;
    total_invoicable!: number;
    total_invoicable_salary!: number;
    total_products!: number;
    products!: ShiftProduct[];
    messages!: Message[];
    checkin_start!: string;
    checkin_start_lat!: string;
    checkin_start_long!: string;
    checkin_end!: string;
    checkin_end_lat!: string;
    checkin_end_long!: string;
    checkin_lunch_start!: string;
    checkin_lunch_start_lat!: string;
    checkin_lunch_start_long!: string;
    checkin_lunch_end!: string;
    checkin_lunch_end_lat!: string;
    checkin_lunch_end_long!: string;
    is_editable!: boolean;
    is_verifiable!: boolean;
    has_started!: boolean
    has_ended!: boolean
    give_feedback!: boolean;
    allow_checkin!: boolean;
    invoicables: ShiftInvoicable[] = [];
    new_order!: boolean;
    paid_with_card!: boolean;
    payment_failed!: boolean;
    card_transaction_id!: string
    card_transaction_time!: Date
    card_transaction_amount!: number
    card_transaction_currency!: string
    card_transaction_error!: string
    total_tax!: number;
    total_discount!: number;
    feedback: Feedback[] = []
    tasks: Task[] = []
    repeat_id!: number
    rejected!: boolean
    ignored!: boolean
    employee_confirmation_deadline!: Date
    allow_canceling!: boolean
    allow_feedback!: boolean
    customer_contact_card_id!: number
    customer_contact_card!: CustomerContactCard
    refund!: number
    discount_percent!: number
    customer_reminded_start!: boolean
    employee_reminded_start!: boolean
    customer_notified_start!: boolean
    breaks: ShiftBreak[] = []
}
